__turbopack_context__.v({
  "popover": "popover-component-module-scss-module__Ih5XXW__popover",
  "popover--flyout": "popover-component-module-scss-module__Ih5XXW__popover--flyout",
  "popover__arrow": "popover-component-module-scss-module__Ih5XXW__popover__arrow",
  "popover__arrow--from-bottom": "popover-component-module-scss-module__Ih5XXW__popover__arrow--from-bottom",
  "popover__button": "popover-component-module-scss-module__Ih5XXW__popover__button",
  "popover__content": "popover-component-module-scss-module__Ih5XXW__popover__content",
});
